var BlockView = require('views/block/base-block-view');
var LocaleService = require('services/locale-service');
import { KeybindingService, keys } from "services/keybinding-service";
const { ArrowDown, ArrowUp, ArrowLeft, ArrowRight, Enter, Space, Escape } = keys;
const AhoyService = require('services/ahoy-service');

/** Example drag and drop sort
    each sortable item can also accept blocks
- type: sort
  id: sortable-list
  srHeader: Rank the sortables
  instructions: instructions
  correct_order_required: true
  sortables:
    - id: sortable1
      header: Apple
      description: fruit
      srText: Apple
      correct_position: 3
    - id: sortable2
      header: Orange
      description: fruit
      srText: Orange
      correct_position: 2
    - id: sortable3
      header: Banana
      description: fruit
      srText: Banana
      correct_position: 1
 */

var SortView = BlockView.extend({
  initialize: function() {
    var normalizeHeaderDesc = (el) => {
      if(el.header && typeof el.header !== 'object') {
        el.header = { text: el.header };
      }
      if(el.description && typeof el.description !== 'object') {
        el.description = { text: el.description };
      }
    };

    this.model.get('sortables').forEach( normalizeHeaderDesc );
    
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
    let selected;
    const sortables = this.$el.find('.sortable');
    
    this.renderMultipleNestedBlocks('sortables');
    
    sortables.on('dragstart', e => {
      e.originalEvent.dataTransfer.effectAllowed = "move";
      e.originalEvent.dataTransfer.setData( "text/plain", null );
      selected = $(e.target);
      this._grab($(e.target));
    });
    
    sortables.on('dragover', e => {
      e.preventDefault();
      e.stopPropagation();
      e.originalEvent.dataTransfer.dropEffect = 'move';
      var bounding = e.target.getBoundingClientRect();
      var offset = bounding.y + (bounding.height/2);
      if ( e.clientY - offset > 0 ) {
        this._move(selected, $(e.target).closest('.sortable'), 'after');
      } else {
        this._move(selected, $(e.target).closest('.sortable'), 'before');
      }
    });

    sortables.on('drop', e => {
      e.preventDefault();
      this._drop($(e.target).closest('.sortable'));
    });

    sortables.on('dragend', e => {
      this._cleanup();
      this.checkComplete();
      selected = null;
    });
    
    sortables.on('keydown', (e) => {
      KeybindingService.with(e)
        .bind([Enter, Space], () => {
          if ($(e.target).hasClass('active')){
            this._drop($(e.target));
          } else {
            this._grab($(e.target),false);
          }
        }, [ArrowUp, ArrowLeft], () => {
          e.preventDefault();
          if ($(e.target).hasClass('active')){
            this._move($(e.target), $(e.target).prev(), 'before');
            this.checkComplete();
            $(e.target).focus();
          } else {
            $(e.target).prev().focus();
          }
        }, [ArrowDown, ArrowRight], () => {
          e.preventDefault();
          if ($(e.target).hasClass('active')){
            this._move($(e.target), $(e.target).next(), 'after');
            this.checkComplete();
            $(e.target).focus();
          } else {
            $(e.target).next().focus();
          }
        }, [Escape], () => {
            this._drop($(e.target));
            $(e.target).focus();
        });
    });
  },
  
  _cleanup() {
    this.$el.find('.sortable')
            .removeClass('active')
            .removeClass('placeholder');
  },
  
  _grab($element, placeholder = true) {
    this._cleanup();
    this.$el.attr('aria-pressed', false);
    $element.addClass('active');
    if (placeholder){
      setTimeout(() => { $element.addClass('placeholder'); }, 1);
    }
    $element.attr('aria-pressed', true);
    this.$el.find('.srText').text( LocaleService.t('sort.grabbed', {srText: this._getSrText($element)}));
  },
  
  _drop($element) {
    this._cleanup();
    $element.attr('aria-pressed', false);
    this.$el.find('.srText').text( LocaleService.t('sort.dropped', {srText: this._getSrText($element)}));
    this.checkComplete();
    AhoyService.track('sort', {action: 'sort', draggable: $element.attr('id'), correct: $element.hasClass('correct'), list: this._getCurrentList()});
  },
  
  _move($element, $toElement, dir) {
    if (dir === 'after'){
      $element.insertAfter($toElement);
    } else {
      $element.insertBefore($toElement);
    }
    this._listUpdatedAlert($element);
    AhoyService.track('sort', {action: 'sort', draggable: $element.attr('id'), correct: $element.hasClass('correct'), list: this._getCurrentList()});
  },
  
  _getSrText($element) {
    return LocaleService.t(this.model.get('sortables').find(x => x.id === $element.attr('id')).srText);
  },
  
  _listUpdatedAlert($element) {
    this.$el.find('.srText').text( LocaleService.t('sort.listUpdated', {srText: this._getSrText($element),
                                                                        position: this.$el.find('.sortable').index($element) + 1,
                                                                        length: this.model.get('sortables').length}));
  },
  
  _checkCorrect() {
    this.$el.find('.sortable').each( (index, element) => {
      if (index + 1 === this.model.get('sortables').find(x => x.id === element.id).correct_position){
        $(element).addClass('correct');
      } else {
        $(element).removeClass('correct');
      }
    });
  },
  
  _getCurrentList() {
    return this.$el.find('.sortable').map(function(){ return this.id; }).get();
  },
  
  play: function() {
    if(this.model.get('correct_order_required')) {
      this.checkComplete();
    } else {
      this.readyToGo();
    }
  },
  
  checkComplete: function() {
    this._checkCorrect();
    let $sortables = this.$el.find('.sortable');
    let position_correct = _.every(this.model.get('sortables'), function(sortable) {
      return sortable.id === $sortables.eq(sortable.correct_position - 1).attr('id');
    });
  
    if(position_correct) {
      AhoyService.track('sort', {action: 'completed', list: this._getCurrentList()});
      this.readyToGo();
    }
  }
});

module.exports = SortView;
